<div class="h1 content-title text-center py-3">Híreink</div>
<div class="blog p-3 col-lg-11 mx-auto">
  <ng-container *ngIf="news && news.length > 0">
    <app-news-post *ngFor="let n of news" [news]="n"></app-news-post>
  </ng-container>
</div>
